import { NgClass } from '@angular/common';
import { Component, computed, HostBinding, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconComponent } from '../../../icons/icon/icon.component';
import { FormFieldHint } from '../../form-field.interface';

@Component({
  selector: 'ui-form-field-hint-details',
  templateUrl: './form-field-hint-details.component.html',
  styleUrls: ['./form-field-hint-details.component.scss'],
  standalone: true,
  imports: [IconComponent, MatTooltipModule, NgClass],
})
export class FormFieldHintDetailsComponent {
  readonly hint = input<FormFieldHint>();
  readonly hintInfo = input<string>();
  readonly position = input<'left' | 'right'>('left');

  @HostBinding('class') get class() {
    return this.position() === 'left' ? 'hint-position-left' : 'hint-position-right';
  }

  readonly hintText = computed(() => {
    const hint = this.hint();
    if (!hint || typeof hint !== 'string') return;
    return hint;
  });

  readonly hintButton = computed(() => {
    const hint = this.hint();
    if (!hint || typeof hint === 'string' || hint.type !== 'button') return;
    return hint;
  });

  readonly hintTextAndLink = computed(() => {
    const hint = this.hint();
    if (!hint || typeof hint === 'string' || hint.type !== 'text-and-link') return;
    return hint;
  });
}
